module.exports = __webpack_public_path__ + "static/media/shieldShape21hollow.fc160d46.png";